/* eslint-disable class-methods-use-this */
import _ from 'lodash';
import * as api from '../../../../utils/apiClient';
import {
  restructureCityNameModel,
  restructureCountryModel,
  restructureRegionModel,
  restructureCityModel
} from './restructuring';
import restructureResponse from '../../../../utils/restructureResponse';

class LocaleService {
  async getCountries(state) {
    const response = await api.get(`/locale/get-countries`, {});
    const responseJson = await response.json();

    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: {
        itemsById: _.keyBy(
          _.map(responseJson.data, item =>
            restructureCountryModel(state, item)
          ),
          'iso_code'
        ),
        itemsIds: _.map(responseJson.data, item => item.country_iso_code)
      }
    };
  }

  async getRegions(state, countryIsoCode) {
    const response = await api.get(`/locale/get-regions/${countryIsoCode}`, {});
    const responseJson = await response.json();

    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: {
        items: _.keyBy(
          _.map(responseJson.data, item => restructureRegionModel(state, item)),
          'iso_code'
        ),
        mapItems: {
          [countryIsoCode]: responseJson.data.map(
            item => item.subdivision_1_iso_code
          )
        }
      }
    };
  }

  async getCities(state, countryIsoCode, regionIsoCode) {
    const response = await api.get(
      `/locale/get-cities/${countryIsoCode}/${regionIsoCode}`,
      {}
    );
    const responseJson = await response.json();

    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: {
        items: _.keyBy(
          _.map(responseJson.data, item => restructureCityModel(state, item)),
          'iso_code'
        ),
        mapItems: {
          [regionIsoCode]: responseJson.data.map(item => item.geoname_id)
        }
      }
    };
  }

  async getCitiesByName(state, cityName) {
    const response = await api.get(`/locale`, { search: cityName });
    const responseJson = await response.json();
    return restructureResponse(
      responseJson,
      responseJson.data,
      restructureCityNameModel
    );
  }
  async getCitiesByIds(state, ids) {
    const response = await api.get(`/locale/get-cities-by-ids`, { ids });
    const responseJson = await response.json();
    return restructureResponse(
      responseJson,
      responseJson.data,
      restructureCityNameModel
    );
  }
}

export default new LocaleService();



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/locale/services/LocaleService/LocaleService.js